var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#29EFA8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_320_5)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.259 16.8778L16.519 24.2333C16.0519 24.503 15.449 24.3414 15.1793 23.8743C14.9096 23.4072 15.0712 22.8043 15.5383 22.5346L28.2783 15.1791C28.7455 14.9094 29.3483 15.071 29.618 15.5381C29.8877 16.0052 29.7262 16.6081 29.259 16.8778ZM31.4657 20.6998L18.7257 28.0552C18.2586 28.3249 17.6557 28.1634 17.386 27.6963C17.1163 27.2291 17.2778 26.6263 17.745 26.3566L30.485 19.0011C30.9521 18.7314 31.555 18.893 31.8247 19.3601C32.0944 19.8272 31.9328 20.4301 31.4657 20.6998ZM33.6723 24.5218L31.549 25.7477C31.0818 26.0174 30.479 25.8559 30.2093 25.3887C29.9396 24.9216 30.1011 24.3187 30.5682 24.049L32.6916 22.8231C33.1587 22.5534 33.7616 22.715 34.0313 23.1821C34.301 23.6492 34.1394 24.2521 33.6723 24.5218ZM28.2607 11.2257L12.1233 20.5426C10.9513 21.2193 10.5492 22.7198 11.2259 23.8919L17.6006 34.9332C18.2773 36.1053 19.7778 36.5074 20.9499 35.8307L37.0872 26.5138C38.2593 25.8371 38.6614 24.3366 37.9847 23.1645L31.6099 12.1232C30.9332 10.9511 29.4328 10.549 28.2607 11.2257Z",
    fill: "#29EFA8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_320_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.2106,
    height: 27.0567,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterCard);
export default __webpack_public_path__ + "static/media/footerCard.289bc11f39bd944ae21f917b4b991837.svg";
export { ForwardRef as ReactComponent };